export default __webpack_public_path__ + "static/media/exam_simulation.f1da0bc0.svg";